// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".navbar-with-back-button .logo-width[data-v-31c025ed]{width:14.6rem}.navbar-with-back-button-back-button[data-v-31c025ed]{left:1.8rem}@media (min-width:1024px){.navbar-with-back-button .logo-width[data-v-31c025ed]{width:20rem}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
